import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { KeyValue } from '../../shared/key-value';
import { AuthorizationService } from '../../shared/authorization.service';
import { IDatasource, IGetRowsParams, GridOptions, GridApi } from 'ag-grid-community';
import { ResetPasswordRendererComponent } from './reset-password-button.component';
import { WorksessionDetailsComponent } from './worksession-details.component';
// import { NguiPopupComponent, NguiMessagePopupComponent } from '@ngui/popup';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-admin-find-user',
  templateUrl: './admin-find-user.component.html',
  styleUrls: ['./admin-find-user.component.css']
})
export class AdminFindUserComponent {
  private gridColumnApi;
  private deleteButtonHandler: any;
  private cancelButtonHandler: any;
  private closeButtonHandler: any;
  gridApi: GridApi;
  context;
  frameworkComponents: any;
  user: any = {};
  activeFilterColumn: string = '';
  errorMsg: string;

  columnDefs = [
    {
      headerName: 'First name',
      field: 'first_name',
      width: 120,
      minWidth: 120,
      filter: true,

      filterParams: {
        filterOptions: ['contains'],
        suppressAndOrCondition: true,
      },
      lockPosition: true,
      onFilterChanged: () => this.clearOtherFilters('first_name'),
    },
    {
      headerName: 'Last name',
      field: 'last_name',
      width: 120,
      minWidth: 120,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],

        suppressAndOrCondition: true,
      },
      lockPosition: true,
      onFilterChanged: () => this.clearOtherFilters('last_name'),
    },
    {
      headerName: 'Email address',
      field: 'email',
      width: 200,
      minWidth: 200,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],

        suppressAndOrCondition: true,
      },
      lockPosition: true,
      onFilterChanged: () => this.clearOtherFilters('email'),
    },
    {
      headerName: 'Role',
      field: 'role',
      width: 100,
      minWidth: 100,
      suppressFilter: true,
      lockPosition: true
    },
    {
      headerName: 'Sessions enrolled',
      field: 'sessions_enrolled',
      width: 200,
      minWidth: 200,
      suppressFilter: true,
      id: 'sessions',
      cellRenderer: 'worksessionDetailsComponent',
      cellStyle: { 'overflow-y': 'auto' },
      colId: 'params',
      lockPosition: true
    },
    {
      headerName: 'Reset password',
      field: 'reset_password',
      cellRenderer: 'resetPasswordRendererComponent',
      colId: 'params',
      width: 150,
      minWidth: 150,
      suppressFilter: true,
      lockPosition: true,
      cellStyle: { textAlign: 'center' },
    }
  ];

  gridOptions: GridOptions = {
    // filter: true,
    pagination: true,
    suppressCellSelection: false,
    rowModelType: 'infinite',
    cacheBlockSize: 10,
    paginationPageSize: 10,
    suppressKeyboardEvent: (params) => { 
      if ((params.colDef.headerName === "First name" && params.event.shiftKey === true) || (params.colDef.headerName === "Sessions enrolled" && params.event.shiftKey === false) || (params.colDef.headerName === "Reset password" && params.event.key === "Tab" && params.event.shiftKey === true)) {
        return true; 
      } else {
        return false;
      }
    },
  };

  constructor(public authService: AuthorizationService, private KeyValueService: KeyValue, private router: Router) {
    this.context = { componentParent: this };
    this.frameworkComponents = {
      resetPasswordRendererComponent: ResetPasswordRendererComponent,
      worksessionDetailsComponent: WorksessionDetailsComponent
    };
  }

  apiService(reqParmas: any) {
    return this.authService.get(KeyValue.api_users, { params: reqParmas })
      .pipe(map(res => res));
  }

  dataSource: IDatasource = {
    getRows: (params: IGetRowsParams) => {
      const reqParmas = {};
      reqParmas['start_offset'] = params.startRow;
      reqParmas['end_offset'] = params.endRow;
      reqParmas['filter_name'] = this.filterName();
      reqParmas['filter_value'] = this.filterValue(this.gridApi.getFilterModel());
      // this.clearOtherFilters();
      this.apiService(reqParmas).subscribe(data => {
        // AXE issue fix, set tabindex to 0
        setTimeout(()=>{
          Array.from(document.getElementsByTagName('ws-details')).forEach(element => {
              //console.log(element);
              element.parentElement.setAttribute('tabindex','0')
            });  
        },2000)

        params.successCallback(
          data.users,
          data.total_records
        );
      });
    }
  }

  onFilterModified() {
    this.gridApi.setDatasource(this.dataSource);
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.setDatasource(this.dataSource);
  }

  filterName() {
    return Object.keys(this.gridApi.getFilterModel());
  }
  filterStatus = {
    first_name: false,
    last_name: false,
    email: false
  };

  clearOtherFilters(columnKey: string) {
    // Clear filters on all columns
    for (const key in this.filterStatus) {
      if (this.filterStatus[key]) {
        this.gridApi.destroyFilter(key);
        this.filterStatus[key] = false;
      }
    }

    // Set the filter status for the current column
    this.filterStatus[columnKey] = true;

    // Apply the filter to the specified column
    this.gridApi.setFilterModel({ [columnKey]: { filterType: 'text', type: 'contains', filter: '' } });
  }

  filterValue(data) {
    let val = '';
    const values = Object.keys(data).map(key => data[key]);
    if (values[values.length - 1]) {
      val = values[values.length - 1]['filter'];
    }
    if (Object.keys(data).indexOf("email") != -1) {
      val = this.encodeSpecialCharacterForEmail(val);
    }
    return val;
  }

  encodeSpecialCharacterForEmail(val) {
    val = val.split('@').join('%40');
    val = val.split(':').join('%3A');
    val = val.split('$').join('%24');
    val = val.split(',').join('%2C');
    val = val.split(';').join('%3B');
    val = val.split('?').join('%3F');
    val = val.split('/').join('%2F');
    val = val.split('+').join('%2B');
    return val
  }

  invokeParentMethod(params: any) {
    this.errorMsg = '';
    console.log(params);
    this.user.email = params.email
    this.showResetPasswordDialog();
  }

  navigateTiAdminHomePage() {
    this.router.navigate([KeyValue.adminPath]);
  }

  showResetPasswordDialog() {
    document.getElementById('reset_password_popup_link').click();
  }

  hideResetPasswordDialog() {
    document.getElementById('resetCancel').click();
  }

  revealPassword(id, image_id) {
    const element = (document.getElementById(id) as HTMLInputElement);
    if (element.type === 'password') {
      element.type = 'text';
      (document.getElementById(image_id) as HTMLInputElement).src = 'assets/images/eye.svg';
    } else {
      element.type = 'password';
      (document.getElementById(image_id) as HTMLInputElement).src = 'assets/images/eye_password.svg';
    }
  }

  clearfields() {
    this.user.newPassword = '';
    this.user.confPassword = '';
    (document.getElementById('newPassword_img') as HTMLInputElement).src = 'assets/images/eye_password.svg';
    (document.getElementById('confPassword_img') as HTMLInputElement).src = 'assets/images/eye_password.svg';
    (document.getElementById('newPassword') as HTMLInputElement).type = 'password';
    (document.getElementById('confPassword') as HTMLInputElement).type = 'password';
  }

  resetPassword(userForm) {
    this.errorMsg = ''
    if (this.user.newPassword == undefined || this.user.newPassword == undefined || this.user.confPassword == undefined || this.user.confPassword == '') {
      this.errorMsg = "Please fill all the fields"
    } else
      if (userForm.valid) {
        this.submit_reset_password();
      }
  }

  setDefaultResetOptions() {
    this.user = {
      email: '',
      newPassword: '',
      confPassword: '',
      role: ''
    };
  }

  submit_reset_password() {
    this.authService.post(KeyValue.api_reset_password, { member_details: this.user, is_admin: true })
      .pipe(map(res => res)).subscribe(
        data => {
          if (data.status == 200) {
            this.setDefaultResetOptions();
            KeyValue.flash_msg_update({ msg: data.message, type: 'success_messages' });
            this.hideResetPasswordDialog();
          }
          else {
            KeyValue.flash_msg_update({ msg: data.errors, type: 'error_messages' });
          }
        },
        error => {
          console.log('Error...' + error);
        }
      );
    this.clearfields();
  }

  private getFocusableElements(modal: HTMLElement): HTMLElement[] {
    return Array.from(
      modal.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    ) as HTMLElement[];
  }

  private trapFocus(modal: HTMLElement): void {
    const focusableElements = this.getFocusableElements(modal);
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];
  
    // Focus the first element
    firstFocusableElement.focus();
  
    // Add event listener for Tab key
    modal.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Tab') {
        if (event.shiftKey) {
          // Shift + Tab: Move focus backward
          if (document.activeElement === firstFocusableElement) {
            event.preventDefault();
            lastFocusableElement.focus();
          }
        } else {
          // Tab: Move focus forward
          if (document.activeElement === lastFocusableElement) {
            event.preventDefault();
            firstFocusableElement.focus();
          }
        }
      }
    });
  }

  invokeDeleteUser(params: any) {
    this.user = params
    document.getElementById('customPopup').style.display = 'flex';

    const modal = document.getElementById('customPopup');
    if(modal) this.trapFocus(modal);

    const messageElement = document.getElementById('customPopup').querySelector('.popup-message');
    messageElement.textContent = "Are you sure you want to delete the user " + params.email + "?";

    // Remove previous event listeners if they exist
    const deleteBtn = document.getElementById('deleteButton');
    const cancelBtn = document.getElementById('cancelButton');
    const closeBtn = document.getElementById('closeButton');

    if (this.deleteButtonHandler) deleteBtn.removeEventListener('click', this.deleteButtonHandler);
    if (this.cancelButtonHandler) cancelBtn.removeEventListener('click', this.cancelButtonHandler);
    if (this.closeButtonHandler) closeBtn.removeEventListener('click', this.closeButtonHandler);

    // Define handlers as arrow functions to preserve 'this'
    this.deleteButtonHandler = () => {
      this.deleteUser();
      document.getElementById('customPopup').style.display = 'none';
    };
    this.cancelButtonHandler = () => {
      document.getElementById('customPopup').style.display = 'none';
    };
    this.closeButtonHandler = () => {
      document.getElementById('customPopup').style.display = 'none';
    };

    deleteBtn.addEventListener('click', this.deleteButtonHandler);
    cancelBtn.addEventListener('click', this.cancelButtonHandler);
    closeBtn.addEventListener('click', this.closeButtonHandler);
  }

  deleteUser() {
    this.authService.delete(KeyValue.api_delete_user + this.user.id, { member_details: this.user, is_admin: true })
      .pipe(map(res => res)).subscribe(
        data => {
          if (data.status === 200) {
            this.gridApi.setDatasource(this.dataSource);
            KeyValue.flash_msg_update({ msg: data.message, type: 'success_messages' });
          } else {
            KeyValue.flash_msg_update({ msg: data.errors, type: 'error_messages' });
          }
        },
        error => {
          console.log('Error...' + error);
        }
      );
  }
}
